/**
 * 使用者類型
 */
export const UserType = {
  /** 維肯內部員工帳號 */
  WenkStaff: 'WenkStaff',
  /** 客戶/公司成員帳號 */
  Customer: 'Customer'
} as const

export type UserType = (typeof UserType)[keyof typeof UserType]

/**
 * 註冊類型
 */
export const RegisterType = {
  /** 系統 - 經由系統註冊 */
  System: 'system',
  /** Oauth - 經由第三方註冊 */
  Oauth: 'oauth'
} as const

export type RegisterType = (typeof RegisterType)[keyof typeof RegisterType]

/**
 * Oauth 註冊類型
 */
export const OauthType = {
  /** Line - 經由Line註冊 */
  Line: 'Line',
  /** Google - 經由Google註冊 */
  Google: 'Google'
} as const

export type OauthType = (typeof OauthType)[keyof typeof OauthType]

/**
 * 使用者頭像尺寸
 */
export const AvatarSize = {
  /** 低畫質頭像 */
  SMALL: 1,
  /** 高畫質頭像 */
  LARGE: 2
} as const

export type AvatarSize = (typeof AvatarSize)[keyof typeof AvatarSize]

/**
 * 個人設定步驟
 */
export const ProfileSteps = {
  /** 顯示個人帳戶資訊 */
  PROFILE_INFO: 'profile-info',
  /** 更新 email 第一步 */
  UPDATE_EMAIL_STEP_1: 'update-email-step-1',
  /** 更新 email 第二步 */
  UPDATE_EMAIL_STEP_2: 'update-email-step-2',
  /** email 更新完成提示 */
  UPDATE_EMAIL_DONE: 'update-email-done',
  /** 更新密碼 */
  UPDATE_PASSWORD: 'update-password',
  /** 更新手機 */
  UPDATE_PHONE: 'update-phone',
  /** 管理第三方帳號綁定 */
  BINDING_ACCOUNT: 'binding-account'
} as const

export type ProfileSteps = (typeof ProfileSteps)[keyof typeof ProfileSteps]
